
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/solutions",
      function () {
        return require("private-next-pages/[locale]/solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/solutions"])
      });
    }
  